<mat-toolbar class="toolbar">
  <h1 class="page-title">
    <mat-icon>add</mat-icon>
    {{'trackers.addTracker'|translate}}
  </h1>

  <lib-button color="none" (click)="closeDialog('cancel')" icon="close">
  </lib-button>
</mat-toolbar>

<div class="tracker-form">
 <div class="form-scrollable">
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>
      {{'form.name'|translate}}
    </mat-label>

    <mat-icon matPrefix fontIcon="track_changes" class="matPrefix"></mat-icon>

    <input type="text" aria-label="text" matInput [(ngModel)]="tracker.name" name="name">
  </mat-form-field>
  <p *ngIf="nameError" class="error-text">{{nameError}}</p>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>
      {{'trackers.serial_number'|translate}}
    </mat-label>

    <mat-icon matPrefix fontIcon="confirmation_number" class="matPrefix"></mat-icon>

    <input type="text" [(ngModel)]="tracker.serial" name="serial" aria-label="text" matInput>
  </mat-form-field>

  <!-- Prefills the form below and links the template - filtered to the form's current type. -->
  <div class="config-select-row">
    <mat-form-field appearance="outline" class="header-input">
      <mat-label>{{'resources.select_config'|translate}}</mat-label>

      <mat-select [value]="editor.appliedTemplateId" (selectionChange)="editor.applyTemplate($event.value)" name="template">
        <mat-option *ngFor="let config of editor.templates" [value]="config.id">{{config.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="template-hint">{{'resources.select_kyd_template_hint'|translate}}</div>

  <app-tracker-config-form [config]="editor.draft" [hideName]="true" (save)="saveTracker()"
    (saveAsTemplate)="onSaveAsTemplate()" (cancelForm)="closeDialog('cancel')"></app-tracker-config-form>
 </div>
</div>
